import { KeyRound } from "lucide-react";

import GlassContainer from "@/shared/components/glasscontainer";
import Button from "@/shared/components/button";
import { useAuth } from "@/features/login/hooks/useAuth";
import { useAsync } from "@/shared/hooks/HookBase";
import AuthService from "@/features/login/services/AuthService";

const authService = new AuthService();

export default function UserAccountPanel() {
  const { user } = useAuth();
  const { loading, execute } = useAsync();

  const requestPasswordChange = async () => {
    if (!user?.email) return;
    await execute(() => authService.forgotPassword({ email: user.email }), {
      successMessage: "Te enviamos un correo para restablecer tu contraseña.",
    });
  };

  return (
    <div className="max-w-3xl space-y-4">
      <GlassContainer className="p-6">
        <div className="flex items-start gap-4">
          <span className="shrink-0 size-8 rounded-full bg-accent/15 text-accent font-bold flex items-center justify-center text-sm">
            <KeyRound className="size-4" />
          </span>
          <div className="flex-1 min-w-0">
            <h3 className="text-lg font-bold text-foreground">Contraseña</h3>
            <p className="text-sm text-foreground/50 mt-0.5 mb-4">
              Te enviaremos un enlace a {user?.email ?? "tu correo"} para elegir una nueva
              contraseña.
            </p>
            <Button variant="secondary" onClick={requestPasswordChange} disabled={loading}>
              {loading ? "Enviando..." : "Solicitar cambio de contraseña"}
            </Button>
          </div>
        </div>
      </GlassContainer>
    </div>
  );
}
